import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Layout } from "../components/global/layout";
import "../style/main.scss";
import { mapEdgesToNodes } from "../lib/helpers";

export const makeLogoUrl = (domain) => `https://img.logo.dev/${domain?.replace(/^https?:\/\//, "")}?token=pk_dtad-naER2mvAHf6021M9w`;

const query = graphql`
  query SiteTitleQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      description
      email
      twitter
      linkedin
      slack
      calendly
      featureFlags
      interfaceTokens {
        label
        value
      }
      _rawProductDisclaimerText(resolveReferences: { maxDepth: 5 })
    }
    assets: allSanityAsset(
      limit: 12
      sort: { fields: [publishedAt], order: DESC }
      filter: {
        status: { in: ["published", "hidden"] }
        _rawBanner: { ne: null }
      }
    ) {
      edges {
        node {
          _type
          _id
          title
          icon
          emoji
          isFeatured
          _rawBanner(resolveReferences: { maxDepth: 5 })
          externalUrl
          paths
          bannerLink
          slug {
            current
          }
          categories {
            _id
            title
            titlePublic
            slug {
              current
            }
          }
        }
      }
    }
  }
`;

export const LayoutContainer = (props) => {
  const { site, assets } = useStaticQuery(query) || {};

  return site ? (
    <Layout {...props} site={{ ...site }} assets={mapEdgesToNodes(assets)} />
  ) : null;
};
